import {
  isCanceledState,
  isPaymentDeniedState,
  isPaymentPendingState,
  isWarningState,
} from './constants'
import { OrderPlacedState } from './typings'
import { hasEcommercePayment } from './utils'

export const getOrderPlacedState = (
  order: Order,
  finishedOrder: boolean
): OrderPlacedState => {
  const status = order.state || order.status

  if (!status) {
    return finishedOrder
      ? OrderPlacedState.IncompleteFinished
      : OrderPlacedState.IncompleteUnfinished
  }

  const hasECommercePayment = hasEcommercePayment(order)

  if (hasECommercePayment && isPaymentDeniedState(status)) {
    return OrderPlacedState.ECommercePaymentDenied
  }
  if (hasECommercePayment && isPaymentPendingState(status)) {
    return OrderPlacedState.ECommercePaymentPending
  }
  if (isCanceledState(status)) {
    return OrderPlacedState.Canceled
  }
  if (isWarningState(status)) {
    return OrderPlacedState.Warning
  }
  return OrderPlacedState.Success
}

export const getOrderGroupState = (
  orderGroup: Order[],
  finishedOrder: boolean
): OrderPlacedState | null => {
  if (!orderGroup || orderGroup.length === 0) {
    return null
  }

  const orderGroupStates = orderGroup.map((order) =>
    getOrderPlacedState(order, finishedOrder)
  )

  if (orderGroupStates.includes(OrderPlacedState.IncompleteFinished)) {
    return OrderPlacedState.IncompleteFinished
  }
  if (orderGroupStates.includes(OrderPlacedState.IncompleteUnfinished)) {
    return OrderPlacedState.IncompleteUnfinished
  }
  if (orderGroupStates.includes(OrderPlacedState.ECommercePaymentDenied)) {
    return OrderPlacedState.ECommercePaymentDenied
  }
  if (orderGroupStates.includes(OrderPlacedState.ECommercePaymentPending)) {
    return OrderPlacedState.ECommercePaymentPending
  }
  if (orderGroupStates.includes(OrderPlacedState.Warning)) {
    return OrderPlacedState.Warning
  }
  if (!orderGroupStates.includes(OrderPlacedState.Canceled)) {
    return OrderPlacedState.Success
  }
  if (!orderGroupStates.includes(OrderPlacedState.Success)) {
    return OrderPlacedState.Canceled
  }

  return OrderPlacedState.Warning
}
